/**
 * EventLocationRow
 *
 * Location input with icon.
 * Google Calendar style.
 */

import { StyleSheet, TextInput, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';

type EventLocationRowProps = {
  value: string;
  onChange: (value: string) => void;
  palette: typeof Colors.light;
};

export function EventLocationRow({ value, onChange, palette }: EventLocationRowProps) {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Ionicons name="location-outline" size={18} color={palette.textMuted} />
      </View>
      <TextInput
        style={[styles.input, { color: palette.text, fontFamily: getBodyFont() }]}
        value={value}
        onChangeText={onChange}
        placeholder="Add location"
        placeholderTextColor={palette.textMuted}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.sm + 2, // 10px
  },
  iconContainer: {
    width: 40,
    alignItems: 'center',
  },
  input: {
    flex: 1,
    fontSize: 14,
    paddingVertical: Spacing.xs,
  },
});
